import $ from 'cash-dom';

// `[pro-con]` on mobile: the Pros/Cons switch shows one column at a time.
export default function initProsConsTabs() {
  const switchTab = (opt) => {
    const box = opt.closest('.pros-cons-box');
    if (!box) {
      return;
    }

    const target = opt.dataset.tab;

    $(box).find('.opt-tab').removeClass('is-active');
    $(opt).addClass('is-active');
    $(box).find('.col-tab').removeClass('active');
    $(box).find(`.${target}`).addClass('active');
  };

  $(document).on('click', '.pros-cons-box .opt-tab', function () {
    switchTab(this);
  });

  $(document).on('keydown', '.pros-cons-box .opt-tab', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      switchTab(this);
    }
  });
}
